// eslint-disable-next-line you-dont-need-lodash-underscore/flatten
import { flatten } from 'lodash';
import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initState = {
  selectedEvidenceCount: 0,
  requiredSelectedEvidenceCount: 0,
  evidence: [],
  isShaking: false,
};

const evidenceReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.DISABLE_EVIDENCE: {
      const { evidenceIndex } = payload;

      const evidence = [...state.evidence];
      evidence[evidenceIndex] = {
        ...state.evidence[evidenceIndex],
        isDiscarded: true,
        isSelected: false,
      };

      const selectedEvidenceCount = state.selectedEvidenceCount - 1;

      return {
        ...state,
        evidence,
        selectedEvidenceCount,
      };
    }
    case REDUX_ACTIONS.TOGGLE_EVIDENCE_SELECTION: {
      const { evidenceIndex } = payload;

      const evidence = [...state.evidence];

      const newEvidenceItem = { ...evidence[evidenceIndex] };
      newEvidenceItem.isSelected = !newEvidenceItem.isSelected;

      evidence[evidenceIndex] = newEvidenceItem;

      const selectedEvidenceCount = newEvidenceItem.isSelected ?
        state.selectedEvidenceCount + 1 : state.selectedEvidenceCount - 1;

      return {
        ...state,
        evidence,
        selectedEvidenceCount,
      };
    }

    case REDUX_ACTIONS.SET_IS_EVIDENCE_PANEL_SHAKING:
      return {
        ...state,
        isShaking: payload.isShaking,
      };

    case REDUX_ACTIONS.INITIALIZE_ITEM:
      return {
        ...state,
        selectedEvidenceCount: 0,
        requiredSelectedEvidenceCount: payload.requiredSelectedEvidenceCount,
        evidence: helperFunctions.parsePageIntoEvidenceData(flatten(payload.evidence)),
      };
    default:
      return state;
  }
};

export default evidenceReducer;

export const parsePageIntoEvidenceData = page =>
  page.map((phrase, index) => ({
    ...phrase,
    evidenceIndex: index,
    isSelected: false,
    isDiscarded: false,
  }));

const helperFunctions = {
  parsePageIntoEvidenceData,
  // parsePagesIntoEvidencePages,
};

export { helperFunctions as _helperFunctions };
